import React from "react";
import { HintView } from "lib/components/index";

const Hint = () => (
  <HintView.Hint>
    <h3>{I18n.t("papp.products.EditProductView.StepAdditional.hint.p1")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepAdditional.hint.p2")}</p>
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepAdditional/StepAdditionalHint.jsx